import FilingStatusesPage from '@playground/features/dictionary/FilingStatusesPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/filing-statuses'
)({
  component: FilingStatusesPage,
})
